import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import arrowLeftIcon from '../../icons/non-prefilled/16x16/arrowLeft.svg';
import arrowRightIcon from '../../icons/non-prefilled/16x16/arrowRight.svg';
import postPath from '../../utils/url/postPath';
import styles from './PostSeriesFooter.module.scss';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import Link from '../../utils/router/Link';

const POST_FRAGMENT = gql(`
  fragment PaginationItem_post on PublicPostFields {
    id
    ...postPath_post
  }
`);

interface PaginationItemProps {
  post?: DocumentType<typeof POST_FRAGMENT> | null;
  prev?: boolean;
}

const PaginationItem = ({ post, prev }: PaginationItemProps) =>
  post ? (
    <Link
      to={postPath(post)}
      className={classNames(styles.paginationItem, {
        [styles.prev]: prev,
        [styles.next]: !prev,
      })}
    >
      <SVGIcon className={styles.icon}>
        {prev ? arrowLeftIcon : arrowRightIcon}
      </SVGIcon>
      <p className={styles.meta}>{prev ? 'Prev' : 'Next'}</p>
      <p className={styles.postTitle}>{post.title}</p>
    </Link>
  ) : null;

const SERIES_FRAGMENT = gql(`
  fragment PostSeriesFooter_series on PublicSeriesFields {
    posts {
      ...PaginationItem_post
    }
  }
`);

interface PostSeriesFooterProps {
  postId: string;
  series: DocumentType<typeof SERIES_FRAGMENT>;
}

const PostSeriesFooter = ({ postId, series }: PostSeriesFooterProps) => {
  const index = series.posts.findIndex((post) => post.id === postId);
  if (index === -1) {
    return null;
  }

  const prev = index > 0 ? series.posts[index - 1] : null;
  const next = index < series.posts.length - 1 ? series.posts[index + 1] : null;

  return (
    <div className={styles.container}>
      <PaginationItem post={prev} prev />
      <PaginationItem post={next} />
    </div>
  );
};

export default PostSeriesFooter;
